import React from 'react';
import { useTheme } from '@mui/system';
import {
	StyledGoalItemProgress,
	StyledGoalItemProgressIcon,
	StyledGoalItemProgressWrap,
} from './styled';

interface PropsType {
	progress: number;
	type: 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success';
}

function GoalItemProgress({ progress, type }: PropsType) {
	const theme = useTheme();
	return (
		<StyledGoalItemProgressWrap>
			<StyledGoalItemProgress variant="determinate" value={progress} />
			<StyledGoalItemProgressIcon sx={{ color: theme.palette[type].contrastText }} />
		</StyledGoalItemProgressWrap>
	);
}

export default GoalItemProgress;
